

$(function() {
  
  //  Clic directo a la página de Tienda en mobile
  $('#menu.panel ul.site-nav li.has-dropdown>a[href$="/collections/tienda"]').parent().addClass('expanded');
  
});





/*--------------------------
    PÁGINA DE INICIO
----------------------------*/

    

/*  carousel de Video
-------------------------*/

$('#carousel-example').on('slide.bs.carousel', function (e) {
    /*
        CC 2.0 License Iatek LLC 2018 - Attribution required
    */
    var $e = $(e.relatedTarget);
    var idx = $e.index();
  var itemsPerSlide = ($('.carousel-item').length >= 8) ? 4 : $('.carousel-item').length / 2 + 1;
    var totalItems = $('.carousel-item').length;

    if (idx >= totalItems-(itemsPerSlide-1)) {
        var it = itemsPerSlide - (totalItems - idx);
        for (var i=0; i<it; i++) {
            // append slides to end
            if (e.direction=="left") {
                $('.carousel-item').eq(i).appendTo('.carousel-inner');
            }
            else {
                $('.carousel-item').eq(0).appendTo('.carousel-inner');
            }
        }
    }
});


$('.carousel').carousel({
  interval: false
});





/*-----------------------------------
    PÁGINA DE COMPRA DE PRODUCTOS
-------------------------------------*/


//  Agregar leyenda compra mínima
// $('.template-product .product-header').prepend('<div class="aviso_envio"> <p> Hacemos envíos a todo México con un mínimo de compra de $1,000 pesos con ENVÍO GRATIS <p> </div>')

//$('.product-header').prepend('<div class="aviso_envio"> <p> Envíos a todo México con un mínimo de compra de <span style="font-weight: bold">$349.00 pesos</span> y en pedidos mayores a <span style="font-weight: bold">$1,000.00 pesos</span> el envío es GRATIS.<p> </div>')
//$('.product-header').append('<div class="aviso_envio"> <p> Por las festividades, si realizas y pagas tu pedido después del 20 de dic, será enviado hasta el 26 dic. Si lo realizas después del 26 dic será enviado hasta el 2 enero. Considerar los 3 o 5 días hábiles que tarda FEDEX en entregar. <p> </div>')
//$('#tu-carrito-de-compras .shipping-at-checkout').prepend('<em>Por las festividades, si realizas y pagas tu pedido después del 20 de dic, será enviado hasta el 26 dic. Si lo realizas después del 26 dic será enviado hasta el 2 enero. Considerar los 3 o 5 días hábiles que tarda FEDEX en entregar.</em>')

/* Bloquear compra poo ser menor a $499.00 */

var minimo_total = function(){
    var subtotal = $('#tu-carrito-de-compras .subtotal .price')
    subtotal = subtotal.text().substring(2,subtotal.text().length)
    subtotal = subtotal.replace(",","");
    subtotal = parseInt(subtotal)
    var boton = $('#tu-carrito-de-compras .cart-checkout input[name="checkout"]');

    if(subtotal < 349 ){
       boton.prop('disabled',true);
       boton.css('background','#99a6cc');
       boton.css('cursor','not-allowed');
      $('#tu-carrito-de-compras .shipping-at-checkout').text('');
      $('#tu-carrito-de-compras .shipping-at-checkout').prepend('<p class="parpadear"> Envíos a todo México con un mínimo de compra de <span style="font-weight: bold">$349.00 pesos (+$100 de envío)</span> y en pedidos mayores a <span style="font-weight: bold">$1000.00 pesos</span> el envío es GRATIS.</p> ')
// 	  $('#tu-carrito-de-compras .shipping-at-checkout').prepend('<p class="parpadear"> Envíos a todo México con un mínimo de compra de <span style="font-weight: bold">$349.00 pesos</span> y en pedidos mayores a <span style="font-weight: bold">$1,000.00 pesos</span> el envío es GRATIS.</p> ')

    }
}

// minimo_total();

//  Reactiva el botón de compra cuando aumenta la cantidad de compra dentro de la misma página de carrito

var minimo_total_boton = function(){
    var subtotal = $('#tu-carrito-de-compras .subtotal .price')
    subtotal = subtotal.text().substring(2,subtotal.text().length)
    subtotal = subtotal.replace(",","");
    subtotal = parseInt(subtotal)
    var boton = $('#tu-carrito-de-compras .cart-checkout input[name="checkout"]');

    if(subtotal < 349 ){
       boton.prop('disabled',true);
       boton.css('background','#99a6cc');
       boton.css('cursor','not-allowed');
      
       $('#tu-carrito-de-compras .shipping-at-checkout').text('');
       $('#tu-carrito-de-compras .shipping-at-checkout').prepend('<p class="parpadear"> Envíos a todo México con un mínimo de compra de <span style="font-weight: bold">$349.00 pesos</span> y en pedidos mayores a <span style="font-weight: bold">$1,000.00 pesos</span> el envío es GRATIS.</p> ')
    
    }else{
       boton.prop('disabled',false);
       boton.css('background','#011b68');
       boton.css('cursor','pointer');
      
       $('#tu-carrito-de-compras .shipping-at-checkout').text('');
       $('#tu-carrito-de-compras .shipping-at-checkout').prepend('<em>Gastos de envío y descuentos calculado al momento de pagar</em>')
    
    }
}

$('#tu-carrito-de-compras .adjust-minus,#tu-carrito-de-compras .adjust-plus').click(function(){
  window.setTimeout(minimo_total_boton, 500);
});



/* Eliminación de compra directa */
var seccion_comprar_ahora = $('.product-aside .shopify-payment-button').css('display','none')


//  Agregar barra de notificación de compra de producto
//  con botón que enlaza al carrito de compra
var titulo = $('.product-title h1').text();
var notificacion = '<div class="alert alert-success notificacion">'+
                        'Se ha añadido <strong>'+ titulo +'</strong> con éxito a tu carrito.'+
                        '<a href="https://ventas-enco.myshopify.com/cart">'+
                            '<span>Ver carrito</span>'+
                        '</a>'+
                   '</div>';

$('.template-product .product-header').after(notificacion);

//  Ocultar el modal de notificación por default
$('.notificacion').css('display','none');

//  Evento del botón Agregar producto a carrito
//  Se desplaza hacia arriba para poder visualizar la barra que aparece
  // $('#AddToCart-product-template').click(function(){
  //     $('.notificacion').fadeOut()
  //     $('.notificacion').fadeIn(2000)
  
  //     $('html,body').animate({scrollTop: 0}, 1000);
  // })


/*-----------------------------------
    PÁGINA CARRITO DE COMPRA
-------------------------------------*/

//  Creación del botón vaciar carrito de compra
var boton = '<a href="/cart/clear" id="vaciarCarrito">'+
    'Vaciar Carrito'+
    '</a>'
$('#tu-carrito-de-compras .right-wrapper').append(boton)



// });



//	Copiar menú productos a footer

var footer_menu_producto = `<li class="has-sub-dropdown expanded" role="presentation">
              <a href="javascript:void(0)" role="menuitem" aria-haspopup="true" aria-expanded="true" tabindex="0">Pastelería y Repostería</a>
              
                <ul class="sub-dropdown" aria-hidden="false" role="menu" style="display: block;">
                  
                  
                    <li class="sub-dropdown-item " role="presentation">
                      <a href="/pages/todos-los-productos" role="menuitem" tabindex="0">¡Descarga el catálogo!</a>
                    </li>
                  
                    <li class="sub-dropdown-item " role="presentation">
                      <a href="/collections/merengue-en-polvo" role="menuitem" tabindex="0">Merengue</a>
                    </li>
                  
                    <li class="sub-dropdown-item " role="presentation">
                      <a href="/collections/productos-colores-en-gel" role="menuitem" tabindex="0">Colores en Gel</a>
                    </li>
                  
                    <li class="sub-dropdown-item " role="presentation">
                      <a href="/collections/productos-royal-icing" role="menuitem" tabindex="0">Royal Icing</a>
                    </li>
					<li class="sub-dropdown-item expanded" role="presentation">
                      <a href="/collections/productos-desmoldante" role="menuitem" tabindex="0">Desmoldante</a>
                    </li>
                  
                    <li class="sub-dropdown-item " role="presentation">
                      <a href="/collections/productos-colores-liquidos" role="menuitem" tabindex="0">Colores Líquidos</a>
                    </li>
                  
                    <li class="sub-dropdown-item " role="presentation">
                      <a href="/collections/productos-esencias" role="menuitem" tabindex="0">Esencias</a>
                    </li>
                  
                    <li class="sub-dropdown-item " role="presentation">
                      <a href="/collections/productos-mix-tres-leches" role="menuitem" tabindex="0">Mix Tres Leches</a>
                    </li>
                  
                </ul>
</li>`



// Preguntas frecuets

if ($(window).width() <= 768) {  

	$('#catalogo-de-pasteleria-y-reposteria footer').prepend(footer_menu_producto);
    $('#merengue footer').prepend(footer_menu_producto);
    $('#colores-en-gel footer').prepend(footer_menu_producto);
    $('#royal-icing footer').prepend(footer_menu_producto);
    $('#desmoldante footer').prepend(footer_menu_producto);
    $('#colores-liquidos footer').prepend(footer_menu_producto);
    $('#esencias footer').prepend(footer_menu_producto);
    $('#mix-tres-leches footer').prepend(footer_menu_producto);
  
//     $('.collapse').on('shown.bs.collapse', function(e) {
//       var $card = $(this).closest('.card');
//       $('html,body').animate({
//         scrollTop: ($card.offset().top - 200)
//       }, 1000);
//   	});
  	
}else{
  
// $('.collapse').on('shown.bs.collapse', function(e) {
//       var $card = $(this).closest('.card');
//       $('html,body').animate({
//         scrollTop: ($card.offset().top - 85)
//       }, 1000);
// });
  
}


//----------------------//
//	       2022		    //
//----------------------77

